import {AfterContentInit, Component, computed, DestroyRef, inject, input, model, ChangeDetectionStrategy} from '@angular/core';
import {ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule} from "@angular/forms";
import {FlexModule} from "@ngbracket/ngx-layout";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-lib-checkbox',
  imports: [
    ReactiveFormsModule,
    FlexModule,
  ],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}]
})
export class CheckboxComponent implements AfterContentInit {
  label = input<string|undefined>(undefined);
  checked = model<boolean>(false);
  parentForm = inject(FormGroupDirective, {optional: true});
  destroyRef = inject(DestroyRef);
  control = input<FormControl | string | null>(null);
  formControl = computed(() => {
    const control = this.control();
    const parentForm = this.parentForm?.form;
    if (control instanceof FormControl) {
      return control;
    }
    if (typeof control === 'string') {
      return parentForm?.get(control) as FormControl;
    }
    return null;
  });
  formControlName = computed(() => {
    const control = this.control();
    if (typeof control === 'string') {
      return control;
    }
    return null;
  });
  toggle() {
    this.checked.update((checked) => !checked);
  }

  ngAfterContentInit() {
    let formControl = this.formControl();
    const formControlName = this.formControlName();
    if (formControlName) {
      formControl = this.parentForm?.form?.get(formControlName) as FormControl;
    }

    if (formControl) {
      if (typeof formControl.value === 'boolean' && formControl.value !== this.checked()) {
        this.checked.set(formControl.value);
      }
      formControl.valueChanges
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((value) => {
        if (typeof value === 'boolean' && value !== this.checked()) {
          this.checked.set(value);
        }
      });
    }
  }
}
